import { addHours, subDays, subHours } from 'date-fns'
import { ILicense, LicenseType } from '../index'
import { ILicenseData } from '../request/response'
import mapRoomsLimitToNumbers from './mapRoomsLimitToNumbers'

export function dateWithoutOffsert(date: Date, debug = false) {
  let d = addHours(date, date.getTimezoneOffset() / 60)

  const offsetDirection = d.getTimezoneOffset() / 60 > 0 ? 1 : -1

  if (d.getHours() !== 0 && !debug) {
    if (d.getHours() === 23) {
      return addHours(d, 1)
    }
    if (d.getHours() === 1) {
      return subHours(d, 1)
    }

    return addHours(d, offsetDirection)
  }

  return d
}

export function addOffsetDate(date: Date) {
  if (date && !isNaN(date as any)) {
    return subHours(new Date(date), new Date(date).getTimezoneOffset() / 60)
  }
  return date ? subHours(date, date.getTimezoneOffset() / 60) : undefined
}

export default function(item: ILicenseData, user): ILicense {
  return {
    license:
      item.license || item.license !== '0'
        ? //Dodałem sekundę celowo xD
          dateWithoutOffsert(new Date(Number(item.license) * 1000), true)
        : '0',
    rawLicense: item.license,
    licenseType: Number(item.license_type),
    has_invoices: Boolean(item.has_invoices),
    has_workers: Boolean(item.has_workers),
    rawDate: new Date(item.license ? +item.license * 1000 : 0),
    source: item.source,
    roomLimit: mapRoomsLimitToNumbers(
      item.rooms,
      Number(item.license_type),
      user.userPriceGroup,
    ),
    active: Number(item.active),
    link: item.link,
    startLicense: item.start_license
      ? dateWithoutOffsert(new Date(Number(item.start_license) * 1000), true)
      : '0',
  }
}

export const mapResponseToService = (item, type) => ({
  id: item.property_id,
  license:
    item.end_time || item.end_time !== '0'
      ? dateWithoutOffsert(new Date(Number(item.end_time) * 1000), true)
      : '0',
  licenseType: mapTypeToLicenseType(type),
  link: item.link,
  rawDate: new Date(item.end_time ? +item.end_time * 1000 : 0),
  startLicense: item.start_license
    ? dateWithoutOffsert(new Date(Number(item.start_license) * 1000), true)
    : dateWithoutOffsert(
        subDays(new Date(Number(item.end_time) * 1000), 30),
        true,
      ),
  status: item.integration_status,
  trial: item.trial,
})

const mapTypeToLicenseType = type => {
  switch (type) {
    case 'booking':
      return LicenseType.LICENSE_BOOKING_COM
    case 'icalendar':
      return LicenseType.LICENSE_ICALENDAR
    case 'invoice':
      return LicenseType.LICENSE_INVOICE
  }
}
